require('./retailLoanStepTwo.scss');
require('./retailLoanStepTwo.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const isEqual = require('lodash/lang/isEqual');
const classNames = require('classnames');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const { OKTextArea } = require('commonsComponents/OKTextArea');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const RetailLoanPersonalData = require('../../contractRetailLoan/retailLoanStepTwo/retailLoanPersonalData/retailLoanPersonalData');
const RetailLoanEmailModal = require('../../contractRetailLoan/retailLoanEmailModal/retailLoanEmailModal');
const { RetailLoanPickupPicker } = require('../retailLoanPickupPicker/retailLoanPickupPicker');
const {
    retailLoanCommons: {
        DATE_PICKER_CUSTOM_DATE_FORMAT,
        TEXT_AREA_MAX_LENGTH,
        YES,
        NO
    },
    retailLoanDoTaggin: {
        NAME_PAGE_WIZARD_VIEW,
        TAGGING_LOAD_EMAIL_MODAL,
    },
    INTERSTITIAL_ODM_DOCUMENT,
    INTERSTITIAL_ODM_DOCUMENT_DOWNLOAD_LINK
} = require('../../../../loansConstants/index');
//@helpers
const {
    buildEventsModal,
    buildLastDescription,
    buildLoadStepRetailLoanInfo,
    poEditorKeyBuilder
} = require('../../../../loansUtilities/loansHelper');
// @ utilities
const {
    recordLinkV2,
    PROC_START, 
    PROC_STEP,
} = require('utilities/tagging');
const DateHelper = require('utilities/dateHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const {
    isRetailAddressDelivery,
} = require('../../../../loansUtilities/loansHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class RetailLoanStepTwo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            showGiftInformation: false
        }

        this.handleInstructionsChange = this.handleInstructionsChange.bind(this);
        this.handleDedicationChange = this.handleDedicationChange.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleGiftOptionChange = this.handleGiftOptionChange.bind(this);
        this.handlePickClick = this.handlePickClick.bind(this);
        this.handleDesciprtionLinkClick = this.handleDesciprtionLinkClick.bind(this);
    }

    componentWillMount() {
        const { immProfileFields, updatePersonalData, immRetailLoan } = this.props;
        const address = PersonalDataHelper.getAddress(immProfileFields);
        const giftOption = immRetailLoan.get("giftOption");
        const showGiftInformation = isEqual(giftOption, YES);

        if (!immRetailLoan.getIn(['personalData', 'typeOfRoads'])) {
            updatePersonalData({ prop: "personalData", personalData: address });
        }
        this.setState({ showGiftInformation });
    }

    componentDidMount() {
        const { getInfoDestinationAccount,
        } = this.props;

        getInfoDestinationAccount();
    }

    componentDidUpdate() {
        const { immRetailLoan } = this.props;
        if (immRetailLoan.get('billingAddressError')) {
            scrollToTop();
        }
    }

    handleToggleModal(tagEvent) {
        if (tagEvent) {
            const customData = buildEventsModal(TAGGING_LOAD_EMAIL_MODAL, tagEvent, NAME_PAGE_WIZARD_VIEW);
            recordLinkV2(customData);
        }
        this.setState({
            showModal: !this.state.showModal
        });
    }

    handleInstructionsChange(event) {
        this.props.formHandlers.handleInstructionsChange({ instructions: event.target.value });
    }

    handleDedicationChange(event) {
        this.props.formHandlers.handleDedicationChange({ dedication: event.target.value });
    }

    handleGiftOptionChange(giftOption) {
        const showGift = isEqual(giftOption, YES);

        this.props.formHandlers.handleGiftOptionChange({ giftOption });
        this.setState({ showGiftInformation: showGift });
    }

    handlePickClick(immItem) {
        const { formHandlers } = this.props;

        formHandlers.handlePickClick({ pickup: immItem });
    }

    buildErrorSection() {
        return (
            <div className="retail-loan-step-two__content-error-addres-form">
                <div>
                    <i className="icon icon-error retail-loan-step-two__icon-error" />
                </div>
                <div className="retail-loan-step-two__content-subtitle-addres-form">
                    <FormattedText value="contractsView-validationErrorStep2Step3" />
                </div>
            </div>
        );
    }

    buildHeader() {
        const { immRetailLoan } = this.props;
        const deliveryDate = immRetailLoan.get('deliveryDate');

        return (
            <header className="retail-loan-step-two__header">
                <div className="row">
                    <div className="col-xs-12">
                        <h4 className="retail-loan-step-two__header-title">
                            <FormattedText value="contractRetailLoanStepTwo-shippingInformation" />
                        </h4>
                    </div>
                    <div className="col-xs-12">
                        <div className="retail-loan-step-two__header-subtitle">
                            <FormattedText value="contractRetailLoanStepTwo-deliveryDate" />
                            {DateHelper.buildFormattedDate(deliveryDate, DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    buildInstructionsBlock() {
        const { immRetailLoan } = this.props;
        const shippingInstructions = immRetailLoan.get('shippingInstructions');

        return (
            <div className="retail-loan-step-two__input-fields-instructions-block">
                <div className="col-xs-12">
                    <div className="retail-loan-step-two__input-fields-instructions-label">
                        <FormattedText value="contractRetailLoanStepTwo-deliveryInstructions" />
                    </div>
                </div>
                <div className="col-xs-12">
                    <OKTextArea
                        label={formatText('contractRetailLoanStepTwo-deliveryRecommendations')}
                        value={shippingInstructions}
                        onChange={this.handleInstructionsChange}
                        maxLength={TEXT_AREA_MAX_LENGTH}
                    />
                </div>
            </div>
        );
    }

    buildSectionPersonalData(isAddressType) {
        const {
            changeBillingAddress,
            changeDeliveryAddressValue,
            immRetailLoan,
            immProfileFields,
            updatePersonalData
        } = this.props;

        const personalDataValues = immRetailLoan.get("personalData");
        return (
            <RetailLoanPersonalData
                personalData={personalDataValues}
                updatePersonalData={updatePersonalData}
                immRetailLoan={immRetailLoan}
                immProfileFields={immProfileFields}
                changeBillingAddress={changeBillingAddress}
                changeDeliveryAddressValue={changeDeliveryAddressValue}
                isAddressType={isAddressType}
            />
        );
    }

    buildEmailData(immProfileFields, isRetailAddressDelivery) {
        const { showModal } = this.state;
        const { immRetailLoan, setEmail } = this.props;

        const email = PersonalDataHelper.getEmail(immProfileFields);
        const userNewEmail = immRetailLoan.get('newEmail') || '';
        const userEmail = userNewEmail !== '' ? userNewEmail : email;
        const titleEmail = !!isRetailAddressDelivery ? 'contractRetailLoanStepTwo-emailInformation' :
            'contractRetailLoanStepTwo-contractRetailLoanStepTwo_emailToReceiveInformation';

        return (
            <div className="col-xs-12">
                <div className="retail-loan-step-two__input-fields-email-content">
                    <div className="retail-loan-step-two__input-fields-email-label">
                        <FormattedText value={titleEmail} />
                        <OKButton modifier="task" onClick={() => this.handleToggleModal()}>
                            <i className="retail-loan-step-two__email-edit-icon icon-editar" />
                        </OKButton>
                    </div>
                    <div className="retail-loan-step-two__input-fields-email">
                        <div className="col-xs-6">
                            <div className="retail-loan-step-two__input-fields-email-value">
                                {userEmail}
                            </div>
                        </div>
                        <div className="col-xs-6 retail-loan-step-two__input-fields-email-edit">
                            <RetailLoanEmailModal
                                showModal={showModal}
                                onHandleToggleModal={this.handleToggleModal}
                                email={userEmail}
                                setEmail={setEmail}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildGiftOptions() {
        const { immRetailLoan } = this.props;
        const dedicationMessage = immRetailLoan.get('dedicationMessage');
        const giftOption = immRetailLoan.get('giftOption');
        const hideGiftClass = classNames('col-xs-12', { 'retail-loan-step-two__gift-dedication-message': !this.state.showGiftInformation });

        const giftOptions = [
            {
                id: NO,
                transKey: 'common-no'
            },
            {
                id: YES,
                transKey: 'common-yes'
            }
        ].map((job, index) => {
            return (
                <RadioButton
                    key={'retailLoanStepTwoGiftOptions-' + index}
                    label={formatText(job.transKey)}
                    value={job.id}
                    className="block-step__radio"
                />
            );
        });

        return (
            <div>
                <div className="col-xs-12">
                    <h4 className="retail-loan-step-two__input-fields-gift-title">
                        <FormattedText value="contractRetailLoanStepTwo-giftOptionsTitle" />
                    </h4>
                </div>
                <div className="col-xs-12">
                    <div className="retail-loan-step-two__input-fields-gift-note">
                        <FormattedText value="contractRetailLoanStepTwo-giftOptionsNote" />
                    </div>
                </div>
                <div className="col-xs-12">
                    <div className="retail-loan-step-two__input-fields-gift-options">
                        <div className="retail-loan-step-two__input-fields-gift-sub-title">
                            <FormattedText value="contractRetailLoanStepTwo-giftQuestion" />
                        </div>
                        <RadioButtonGroup
                            name="job"
                            idPrefix="jobRadio"
                            onChange={this.handleGiftOptionChange}
                            className="payroll-loan-request-step-one__input-fields-radio-group"
                            selectedValue={giftOption}
                        >
                            {giftOptions}
                        </RadioButtonGroup>
                    </div>
                </div>
                <div className={hideGiftClass}>
                    <OKTextArea
                        label={formatText('contractRetailLoanStepTwo-giftDedicationMessage')}
                        value={dedicationMessage}
                        onChange={this.handleDedicationChange}
                        maxLength={TEXT_AREA_MAX_LENGTH}
                    />
                </div>
            </div>
        );
    }

    buildPickupPicker() {
        const { immRetailLoan, immSelectedItem } = this.props;
        const immOffice = immSelectedItem.getIn(['field_retail_provider', 'office_location']);
        const immSelectedOffice = immRetailLoan.get('selectedPickup');

        return (
            <div className="col-xs-12 retail-loan-step-two__pickup">
                <h4 className="retail-loan-step-two__header-title">
                    <FormattedText value="retailLoanCommon-retailLoanCommon_pickerTitle" />
                </h4>
                <div className="retail-loan-step-two__pickup-description">
                    <FormattedText value="contractRetailLoanStepTwo-contractRetailLoanStepTwo_pickerDescription" />
                </div>
                <div className="retail-loan-step-two__pickup-container">
                    <RetailLoanPickupPicker
                        immOffice={immOffice}
                        immSelectedOffice={immSelectedOffice}
                        onPickClick={this.handlePickClick}
                    />
                </div>
            </div>
        );
    }

    buildInputFields(immProfileFields, isAddressType) {
        const { immFlagBasedFeatures } = this.props;

        const personalData = this.buildSectionPersonalData(isAddressType);
        const buildEmailData = this.buildEmailData(immProfileFields, isAddressType);
        const instructionsBlock = isAddressType ? this.buildInstructionsBlock() : null;
        const pickupPicker = !isAddressType ? this.buildPickupPicker() : null;
        const isGiftOptionsEnabled = immFlagBasedFeatures.get('loan-retail-gift-enabled', false);
        const giftOptions = isGiftOptionsEnabled ? this.buildGiftOptions() : null;

        return (
            <div className="retail-loan-step-two__input-fields">
                <div className="row">
                    {personalData}
                    {buildEmailData}
                    {instructionsBlock}
                    {giftOptions}
                    {pickupPicker}
                </div>
            </div>
        );
    }

    handleDesciprtionLinkClick() {
        const { immRetailLoan } = this.props;
        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const visibleStep = immRetailLoan.get('visibleStep');
        const customData = {
            categoriaEvento: NAME_PAGE_WIZARD_VIEW,
            accionEvento: formatText('payrollLoanStepTwoDisclaimer-payrollLoanStepTwoDisclaimer_link'),
            etiquetaEvento: immSelectedItem.get('title'),
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };

        recordLinkV2(customData);
        window.open(INTERSTITIAL_ODM_DOCUMENT_DOWNLOAD_LINK);
    }

    buildCheckoutSection() {

        const poEditorMessage = poEditorKeyBuilder('payrollLoanStepTwoDisclaimer', 'message');

        const injectedLinks = [
            { docType: INTERSTITIAL_ODM_DOCUMENT, text: poEditorKeyBuilder('payrollLoanStepTwoDisclaimer', 'link'), onHandlerClick: this.handleDesciprtionLinkClick },
        ];

        const lastDescription = buildLastDescription(poEditorMessage, injectedLinks);
        return (
            <div className="contract-loan-due-information">
                <OKMessage type="informative">
                    <span className="contract-loan-due-information__message">
                        {lastDescription}
                    </span>
                </OKMessage>
            </div>
        )
    }

    render() {
        const { immProfileFields, immRetailLoan, immSelectedItem } = this.props;

        const isAddressType = isRetailAddressDelivery(immSelectedItem.get('field_pickup_option'));

        const errorSection = immRetailLoan.get('billingAddressError') ? this.buildErrorSection() : null;
        const header = isAddressType ? this.buildHeader(immProfileFields) : null;
        const inputFields = this.buildInputFields(immProfileFields, isAddressType);
        const checkoutMessage = this.buildCheckoutSection();

        return (
            <section className="retail-loan-step-two">
                {errorSection}
                {header}
                {inputFields}
                {checkoutMessage}
            </section>
        );
    }
}

RetailLoanStepTwo.propTypes = {
    beforeStep: PropTypes.number,
    changeBillingAddress: PropTypes.func.isRequired,
    changeDeliveryAddressValue: PropTypes.func.isRequired,
    errorAsnef: PropTypes.bool,
    formHandlers: PropTypes.object.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getInfoDestinationAccount: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    immSelectedItem: PropTypes.object.isRequired,
    setEmail: PropTypes.func.isRequired,
    updatePersonalData: PropTypes.func.isRequired
};

module.exports = RetailLoanStepTwo;
